import React, { forwardRef, type ComponentProps } from 'react';
import { cn } from '@mentimeter/ragnar-tailwind-config';
import { Item } from '@radix-ui/react-dropdown-menu';
import {
  menuItemVariants,
  type MenuItemVariantProps,
} from '../MenuItem.variants';

export type DropdownMenuItemProps = ComponentProps<typeof Item> & {
  variant?: MenuItemVariantProps['variant'];
};

export const DropdownMenuItem = forwardRef<
  HTMLDivElement,
  DropdownMenuItemProps
>((props, ref) => {
  const { className, variant, ...rest } = props;
  return (
    <Item
      className={cn(menuItemVariants({ variant }), className)}
      ref={ref}
      {...rest}
    />
  );
});
